import api from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../css-loader/index.js!./vuejs-dialog.min.css";

var options = {"attributes":{"rel":"preload","as":"style"}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};


//////////////////
// WEBPACK FOOTER
// ./~/vuejs-dialog/dist/vuejs-dialog.min.css
// module id = 963
// module chunks = 113